import React, {useState,useContext} from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import { authContext } from './AuthContext';

const SignIn = ({}) => {
  const [login, setLogin] = useState();
  const [password, setPassword] = useState();
  const { setAuthData } = useContext(authContext);
  const { auth } = useContext(authContext);
  const navigate = useNavigate();

  const onFormSubmit = e => {
    e.preventDefault();

    fetch ('https://mel.dvrc.fr/api/auth.php', {
			method: 'POST',
			body: JSON.stringify({'login': login,mdp: password}),
			headers: {"Content-type": "application/json; charset=UTF-8"}
		})
        .then(res => res.json())
        .then((data) => {
          if(data.token){
            fetch("https://mel.dvrc.fr/api/zones.php?token="+data.token).then(res => res.json())
              .then( (zones) => {
                data.zones = zones;
                if(!data.zone && zones[0])
                  data.zone = zones[0];
                setAuthData(data);
                navigate('/');
            })
          }
        }).catch(console.log)
  };

  const onFormQuit = e => {
      e.preventDefault();
      setAuthData(null);
    };

  if(auth.data){
    return (
      <div
        style={{ height: "100vh" }}
        className="d-flex justify-content-center align-items-center"
      >
        <div style={{ width: 300 }}>
          <h1 className="text-center">Sign Out</h1>
        <Form onSubmit={onFormQuit}>
            <Button
              variant="primary"
              type="submit"
              className="w-100 mt-3">
              Quit
            </Button>
          </Form>
        </div>
      </div>
    );
  } else
  return (
    <div
      style={{ height: "100vh" }}
      className="d-flex justify-content-center align-items-center"
    >
      <div style={{ width: 300 }}>
        <h1 className="text-center">Sign in</h1>
        <Form onSubmit={onFormSubmit}>
          <Form.Group>
            <Form.Label>Login</Form.Label>
            <Form.Control
              type="login"
              placeholder="Enter login"
              onChange={e => {
                setLogin(e.target.value);
              }}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Password"
              onChange={e => {
                setPassword(e.target.value);
              }}
            />
          </Form.Group>
          <Button
            variant="primary"
            type="submit"
            className="w-100 mt-3">
            Sign in
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default SignIn;
